import { UI, VStack } from '@genial/components';
import { Box, Modal, ScrollView } from 'native-base';
import { useState } from 'react';
import { Dimensions } from 'react-native';

import { Timeline } from '../../../../components/Timeline';
import { useSubscriptionDetailContext } from '../../contexts/SubscriptionDetail';

import { SubscriptionItemDetailsFooter } from './components/SubscriptionItemDetailsFooter';
import { SubscriptionItemDetailsHeader } from './components/SubscriptionItemDetailsHeader';
import { SubscriptionItemDetailsInfos } from './components/SubscriptionItemDetailsInfos';

export const SubscriptionItemDetails = () => {
  const { height } = Dimensions.get('window');
  const [timelineOpen, setTimelineOpen] = useState(true);

  const { modalOpen, subscriptionSelected, setModalOpen } = useSubscriptionDetailContext();

  const handleClose = () => {
    setModalOpen(false);
  };

  if (!subscriptionSelected) {
    return <></>;
  }

  return (
    <UI.Modal isOpen={modalOpen} onClose={handleClose} testId="modal-details">
      <Modal.Content
        bg="neutral.white"
        alignItems="center"
        w="full"
        maxH={{ base: height * 0.75, lg: 'full' }}
        maxW={{ base: 'full', lg: '909px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}>
        <ScrollView w="full" showsVerticalScrollIndicator={false}>
          <VStack p="inset.md" space="stack.xxxs">
            <SubscriptionItemDetailsHeader
              title={subscriptionSelected.productDisplay}
              subtitle={subscriptionSelected.baseIsinCode}
              handleClose={handleClose}
            />
            <Box w="full" h="1px" bgColor="neutral.lightest" />
            <SubscriptionItemDetailsInfos
              infos={[
                { label: 'Tipo Evento', value: subscriptionSelected.eventType },
                {
                  label: 'Código de negociação base',
                  value: subscriptionSelected.negotiationBaseCode,
                },
                { label: 'Empresa', value: subscriptionSelected.companyName },
                { label: 'Código Isin base', value: subscriptionSelected.baseIsinCode },
                { label: 'Código Isin destino', value: subscriptionSelected.destinationIsinCode },
              ]}
            />
            <Timeline
              title="Cronograma"
              ableToClose
              isOpen={timelineOpen}
              onToggle={() => setTimelineOpen(!timelineOpen)}
              timeline={subscriptionSelected.timelineItems}
            />
            <SubscriptionItemDetailsFooter
              title="O que é/são Subscrição?"
              subtitle="Consiste no aumento de capital de uma empresa à partir do lançamento de novas ações, com intuito de capitar novos recursos. Os acionistas da companhia têm preferência na compra desses ativos, em proporções que dependem da quantidade já possuída por cada sócio, pelo preço e prazo preestabelecidos. Essa preferência recebe o nome de direito de subscrição."
            />
          </VStack>
        </ScrollView>
      </Modal.Content>
    </UI.Modal>
  );
};
